// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a43c2c80","513":"66d43ecc","703":"c924fcc1","787":"b9541cb3"}[chunkId] + ".chunk.js";
};